import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  labelBlackListedMessage: (
    <PortalMessage
      id='t.app.costs.table.detail.blacklisted.message'
      defaultMessage='Per scaricare il dettaglio transazioni, restringi il periodo di riferimento a 1 mese.'
    />
  )
}

export default formattedMessage
